<template>
  <div class="expand-button" @click="toggleExpand">
    <button class="btn n-btn" :title="btnTitle">
      <svg v-if="isActive" class="icon"><use href="#arrows-minimize" /></svg>

      <svg v-else class="icon"><use href="#arrows-maximize" /></svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ExpandButton',

  data() {
    return {
      isActive: false,
      texts: theme_vars.mapText,
    };
  },

  computed: {
    btnTitle() {
      return this.isActive ? this.texts.minimizeText : this.texts.maximizeText;
    },
  },

  methods: {
    toggleExpand() {
      const sectionMap = document.getElementById('section-map');
      sectionMap.classList.toggle('expanded');
      this.isActive = !this.isActive;
    },
  },
};
</script>
